// extracted by mini-css-extract-plugin
export var linkButton = "link-button-module--link-button--vkbz-";
export var linkButtonPrimary = "link-button-module--link-button--primary--gp-rP";
export var linkButtonSecondary = "link-button-module--link-button--secondary--2RGbO";